import _ from 'lodash';

export default {
  namespaced: true,
  state: {
    currentSeason: undefined,
    seasons: undefined
  },
  mutations: {
    updateCurrentSeason(state, payload) {
      state.currentSeason = payload.season;
    },
    updateSeasons(state, payload) {
      state.seasons = payload.seasons;
    },
  },
  actions: {
    async setup({ commit }) {
      const res = await this._vm.$http.get('assemble/api/v1/admin/seasons/current');
      const seasons = await this._vm.$http.get('assemble/api/v1/admin/seasons');
      if (res.data.data) commit('updateCurrentSeason', res.data.data);
      if (seasons.data.data) {
        // map seasons to value and sort by value

        let seasonsMapped = _.map(seasons.data.data.seasons, (season) => {
          const value = season._id;
          return {
            value,
            label: season._id,
            currentSeason: season.currentSeason
          };
        });
        seasonsMapped = seasonsMapped.sort((a, b) => a.value - b.value);
        commit('updateSeasons', { seasons: seasonsMapped });
      }
    }
  },
  getters: {
    currentSeason(state) {
      return _.get(state, 'currentSeason');
    },
    seasons(state) {
      return _.get(state, 'seasons');
    },
    latestSeason(state) {
      const { seasons } = state;
      if (!seasons) return undefined;
      return seasons.find((season) => season.currentSeason)?.value;
    }
  },
};
